// extracted by mini-css-extract-plugin
export default {"root":"Input_root__U6Ujg","number":"Input_number__EWCoX","search":"Input_search__6sEr6"};